import { FC } from "react";
import { Outlet } from "react-router-dom";
import "./public-layout.scss";
import { Header } from "@components/header";
import { useFavicon } from "@hooks/use-favicon";

const PublicLayout: FC = () => {
  useFavicon("./logo.png");
  return (
    <main className="template">
      <div className="content-area w-100">
        <div className="header-area">
          <Header basePath="/auth/signin" />
        </div>
        <Outlet />
      </div>
    </main>
  );
};

export default PublicLayout;
